<ng-content></ng-content>
<mat-error align="end" *ngIf="validateOn.includes('required')" [class.hidden]="model.valid || model.pristine">
  Required Field
</mat-error>